<script setup>
import { onMounted, ref } from 'vue';
import AOS from 'aos';

import ServiceCard from '@/components/services/ServiceCard.vue';
import HowWeWork from '@/components/services/HowWeWork.vue';

import imgFreight from '@/assets/rectangle-13@2x.png';
import imgFleet from '@/assets/rectangle-12@2x.png';
import imgShe from '@/assets/rectangle-16@2x.png';
import imgTraining from '@/assets/logisticsTraining.webp';

const services = ref([
  {
    titleKey: 'services-page.body.freight-management-divs[0].service',
    image: imgFreight,
    points: [
      'services-page.body.freight-management-divs[0].content[0]',
      'services-page.body.freight-management-divs[0].content[1]',
      'services-page.body.freight-management-divs[0].content[2]',
    ],
  },
  {
    titleKey: 'services-page.body.freight-management-divs[1].service',
    image: imgFleet,
    points: [
      'services-page.body.freight-management-divs[1].content[0]',
      'services-page.body.freight-management-divs[1].content[1]',
      'services-page.body.freight-management-divs[1].content[2]',
    ],
  },
  {
    titleKey: 'services-page.body.freight-management-divs[2].service',
    image: imgShe,
    points: ['services-page.body.freight-management-divs[2].content[0]'],
  },
  {
    titleKey: 'services-page.body.freight-management-divs[3].service',
    image: imgTraining,
    points: ['services-page.body.freight-management-divs[3].content[0]'],
  },
]);

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true,
  });
});
</script>

<template>
  <div class="hero-section">
    <div class="hero-overlay"></div>
    <h1 class="title" data-aos="fade-up">{{ $t('services-page.home.title') }}</h1>
  </div>

  <main class="main-content">
    <div class="services-list">
      <ServiceCard
        v-for="(service, index) in services"
        :key="index"
        :titleKey="service.titleKey"
        :image="service.image"
        :points="service.points"
        :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
      />
    </div>
  </main>

  <HowWeWork />
</template>

<style scoped>
.hero-section {
  background: url("../assets/rectangle-30@2x.webp") center center;
  background-size: cover;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 45, 97, 0.6);
}

.title {
  text-transform: uppercase;
  color: white;
  font-size: 3rem;
  position: relative;
  z-index: 2;
  padding-bottom: 0.5rem;
}

.title::after {
  content: "";
  position: absolute;
  background: #fcbc0d;
  width: 80px;
  height: 4px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.main-content {
  padding: 6rem 5%;
}

.services-list {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }
}
</style>
